export enum CreativeTypeName {
  FOLDER = 'Folder',
  PLAY = 'Play',
  CANVAS = 'Canvas',
}

export default CreativeTypeName;
